import { AxiosPromise } from 'axios';
import { Api, MarketApi } from '@/utils/http';
import { getSensorsData } from '@/utils/sensors';

// 发送验证码
export const fetchSendCaptcha = (body:AccountAPI.Request.ISendCaptcha) =>
  ():AxiosPromise => {
    const { ticket, ...reset } = body;
    return Api.post('/tiger/v3/web/accounts/captcha/login/silence', reset, {
      headers: { 'X-Captcha-Ticket': ticket },
    });
  };

// 账号密码登录
export const fetchAccountLogin = (body:AccountAPI.Request.IAccountLogin) =>
  ():AxiosPromise<AccountAPI.Response.ILogin> =>
    Api.post('/tiger/v3/web/accounts/login', body, {
      headers: {
        'SENSORS-DATA': getSensorsData(),
      },
    });

// 手机验证码登录
export const fetchMobileLogin = (body:AccountAPI.Request.IMobileLogin) =>
  ():AxiosPromise<AccountAPI.Response.ILogin> =>
    Api.post('/tiger/v3/web/accounts/phone/login', body, {
      headers: {
        'SENSORS-DATA': getSensorsData(),
      },
    });

// 获取当前用户信息
export const fetchGetUserInfo = ():AxiosPromise<AccountAPI.Response.IUserInfo> =>
  MarketApi.get('/users/info');

// 退出登录
export const fetchLogout = ():AxiosPromise =>
  Api.post('/tiger/v3/web/accounts/logout');

// 获取微信JSSDK配置
export const fetchWechatJSSDK = (body:AccountAPI.Request.IWechatJSSDK):AxiosPromise<AccountAPI.Response.IWechatJSSDK> =>
  Api.post('/tiger/wechat/config/js_sdk', body);

